// extracted by css-extract-rspack-plugin
export default {"navItem":"SavedViewItem-module__navItem__Wfvh1","truncatedItemText":"SavedViewItem-module__truncatedItemText__kVSQQ","icon":"SavedViewItem-module__icon__aEccP"};